module.exports = __webpack_public_path__ + "img/9791187038047.e886a4e8.jpg";